__turbopack_context__.v({
  "accordeonItem": "style-module-scss-module__4LZEhq__accordeonItem",
  "activator": "style-module-scss-module__4LZEhq__activator",
  "activatorIcon": "style-module-scss-module__4LZEhq__activatorIcon",
  "activatorTitle": "style-module-scss-module__4LZEhq__activatorTitle",
  "content": "style-module-scss-module__4LZEhq__content",
  "contentShell": "style-module-scss-module__4LZEhq__contentShell",
  "industry": "style-module-scss-module__4LZEhq__industry",
  "inner": "style-module-scss-module__4LZEhq__inner",
  "opened": "style-module-scss-module__4LZEhq__opened",
  "section": "style-module-scss-module__4LZEhq__section",
  "title": "style-module-scss-module__4LZEhq__title",
  "titleWrapper": "style-module-scss-module__4LZEhq__titleWrapper",
});
